import { connect } from 'react-redux';
import { MaintenanceSchedulePres } from 'src/ui/features/Maintenance/presentational/MaintenanceSchedulePres';
import { setMaintenanceScheduleRead } from 'src/ui/features/Maintenance/state/maintenanceActions';

const mapStateToProps = ({ maintenance }) => {
  return { maintenance };
};

const mapDispatchToProps = {
  setMaintenanceScheduleRead,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceSchedulePres);
